import { Button, Typography } from '@mui/material';
import React from 'react';
import { MainStyles } from '../constants';
import { omsWebConfig, webUrlConfig } from '../../../services/config';

const RedirectOmsCTA = () => {
  const partnerCode = sessionStorage.getItem('partnerCode');
  const token = sessionStorage.getItem('token');
  const partnerCategory = sessionStorage.getItem('partnerCategory');

  return (
    <Button
      sx={MainStyles.DoneButton}
      onClick={() => {
        if (partnerCategory === 'partner') {
          window.location.href = `${omsWebConfig('blr')}/eclinic/${partnerCode}?token=${token}`; // Set this as blr, will have to pass it on if we enable it to more cities.
        } else {
          window.location.href = `${webUrlConfig()}/web-order/e-clinic/?partner_code=${partnerCode}&token=${token}&utm_campaign=clinic_frontdesk`;
        }
      }}
    >
      <Typography sx={MainStyles.DoneText}> Done</Typography>
    </Button>
  );
};

export default RedirectOmsCTA;
